module.exports = __webpack_public_path__ + "static/media/refugee.a2bbef6b.jpg";